import React from "react";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
// import Ranking from "../../../Components/Dashboard/Ranking";
import RmsAlert from "../../../Components/Dashboard/DashBoardDefault/RmsAlert";
import BusinessSnapshot from "../../../Components/Dashboard/DashBoardDefault/BusinessSnapshot";
import BirthdaySlider from "../../../Components/Dashboard/BirthdaySlider";
import TopActiveClientTable from "../../../Components/Dashboard/ActiveClientTable";
import TopInActiveClientTable from "../../../Components/Dashboard/InActiveClientTable";
// import ClientStatus from "../../../Components/Dashboard/ClientStatus";
import { DASHBOARD_DEFAULT } from "../../../Configuration/API_URL";
import { Constants } from "../../../CommonMethhods/Constants";
import NewClientStatus from "../../../Components/Dashboard/NewClientStatus";
import NewRanking from "../../../Components/Dashboard/NewRanking";
// import StockSegmentation from "../../../Components/Dashboard/DashboardEquity/StockSegmentation";
import ClientStatusGraph from "../../../Components/Dashboard/DashboardEquity/ClientStatusGraph";
// import BrokerageSummary from "../../../Components/Dashboard/DashboardEquity/BrokerageSummary";
// import Research from "../../../Components/Dashboard/DashboardEquity/Research";
import ClientInFo from "../../../Components/Dashboard/DashboardEquity/ClientInFo";
import IpoDetail from "../../../Components/Dashboard/DashboardEquity/IpoDetail";
import SummaryReactivation from "../../../Components/Dashboard/DashBoardDefault/SummaryReactivation";
import NewQuickLink from "../../../Components/Dashboard/NewQuickLink";

function DashboardDefault() {
  const filterTabsId = [
    "defaultYearly",
    "defaultQuarterly",
    "defaultMonthly",
    "defaultWeekly",
  ];
  return (
    <>
      <div
        className="tab-pane fade show active"
        id="default"
        role="tabpanel"
        aria-labelledby="default-tab"
      >
        {/* Buisness Snapshot */}
        <BusinessSnapshot />
        {/* Buisness Snaphot end */}

        {/* clientStatus */}

        {/* <ClientStatus
          filterTabsId={filterTabsId}
          getClientStatus={DASHBOARD_DEFAULT.ClientStatus_URL}
        /> */}

        <NewClientStatus
          filterTabsId={filterTabsId}
          getClientStatus={DASHBOARD_DEFAULT.ClientStatus_URL}
        />
        {/* Client Status End */}

        {/* Top active inactive */}
        <div className="row bottom-25">
          <div className="col-md-12 col-lg-6 gap-20">
            <TopActiveClientTable
              getActiveClientInfo={DASHBOARD_DEFAULT.TopActiveClient_URL}
            />
          </div>
          <div className="col-md-12 col-lg-6">
            <TopInActiveClientTable
              getInActiveClientInfo={DASHBOARD_DEFAULT.TopInActiveClient_URL}
            />
          </div>
        </div>
        {/* Top active inactive end*/}

        {/* new ranking */}

        <div className="row bottom-25">
          <div className="col-lg-6 col-md-12 ipad-bottom-20 mobile-bottom-20">
            <NewRanking
              getNewRankingInfo={DASHBOARD_DEFAULT.NewDefaultRanking_URL}
            />
          </div>
          <div className="col-lg-6 col-md-12">
            <NewQuickLink />
          </div>
        </div>

        <div className="card-box bottom-25">
          <div className="card-title">
            <h2>{Constants.Actionable}</h2>
          </div>
          <div className="row">
            {/* Birthday card start */}
            <div className="col-md-12 col-lg-6">
              <BirthdaySlider />
            </div>
            {/* Birthday card end */}
            {/* RMS Start */}
            <div className="col-md-12 col-lg-6">
              <RmsAlert />
            </div>
            {/* RMS End */}
          </div>
        </div>
        <div className="stock-broking-wrapper">
          <div className="row bottom-25">
            <div className="col-12 col-md-7 col-lg-6 col-xl-4 bottom-desktop-base mobile-bottom-20">
              <ClientStatusGraph />
              {/* <StockSegmentation /> */}
            </div>
            <div className="col-12 col-md-5 col-lg-6 col-xl-4 bottom-desktop-base mobile-bottom-20">
              <IpoDetail />
            </div>
            <div className="col-12 col-md-12 col-lg-12 col-xl-4">
              {/* <BrokerageSummary /> */}
              <ClientInFo />
            </div>
          </div>
        </div>
        {/* <div className="stock-broking-wrapper">
          <div className="row bottom-25">
            <div className="col-md-12 col-lg-6 gap-20">
              <Research />
              <IpoDetail />
            </div>
            <div className="col-md-12 col-lg-6">
              <ClientInFo />
            </div>
          </div>
        </div> */}
        {/* <div className="stock-broking-wrapper">
          <div className="row bottom-25">
            <div className="col-md-12 col-lg-12">
              <Research />
            </div>
          </div>
        </div> */}

        {/* Summary area start */}

        <SummaryReactivation />
        {/* Summary area end */}
      </div>
    </>
  );
}

export default DashboardDefault;
